// extracted by mini-css-extract-plugin
export default {"container":"CardsPay_container__EmRkO","flex":"CardsPay_flex__EHvTl","box":"CardsPay_box__bOP+d","imge":"CardsPay_imge__fGes8","check":"CardsPay_check__rG9gR"};